// Estilos globais (CSS) do app.
// Extraído de App.js sem alteração de comportamento.
import { hexToRgb, useTheme } from "../lib/theme";

// ── AUTH: Login / Cadastro ────────────────────────────────────────────────────
export function GlobalStyles() {
  const t = useTheme();
  const ac = t ? t.ac : "#60a5fa";
  const [r, g, b] = hexToRgb(ac);
  // brilho do logo: branco no escuro; no claro dos estilos novos usa a cor do texto (senão some)
  const logoShine = t && t.style !== "classico" && t.mode === "light" ? t.text : "#fff";
  return (
    <style>{`

      :root {
        --g17-body: ${t ? t.fontBody : "'Outfit',system-ui,sans-serif"};
        --g17-display: ${t ? t.fontDisplay : "'Barlow Condensed',sans-serif"};
        --g17-mono: ${t ? t.fontMono : "'JetBrains Mono',monospace"};
      }
      *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
      html, body {
        height: 100%; width: 100%;
        overflow: hidden; overscroll-behavior: none;
        background: ${t ? t.bg : "#060a14"};
        font-family: var(--g17-body);
        -webkit-font-smoothing: antialiased;
        cursor: default;
      }
      #root { height: 100%; width: 100%; overflow: hidden; }

      /* ── KEYFRAMES ── */
      @keyframes spin { to { transform: rotate(360deg); } }

      @keyframes fadeUp {
        from { opacity: 0; transform: translateY(20px) scale(0.98); }
        to   { opacity: 1; transform: translateY(0) scale(1); }
      }
      @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

      @keyframes slideInLeft {
        from { opacity: 0; transform: translateX(-24px); }
        to   { opacity: 1; transform: translateX(0); }
      }
      @keyframes slideInRight {
        from { opacity: 0; transform: translateX(24px); }
        to   { opacity: 1; transform: translateX(0); }
      }
      @keyframes slideUp {
        from { opacity: 0; transform: translateY(12px); }
        to   { opacity: 1; transform: translateY(0); }
      }
      @keyframes scaleIn {
        from { opacity: 0; transform: scale(0.88) translateY(8px); }
        to   { opacity: 1; transform: scale(1) translateY(0); }
      }
      @keyframes bounceIn {
        0%   { opacity: 0; transform: scale(0.6); }
        55%  { opacity: 1; transform: scale(1.08); }
        75%  { transform: scale(0.97); }
        100% { transform: scale(1); }
      }
      @keyframes shimmer {
        0%   { background-position: -600px 0; }
        100% { background-position: 600px 0; }
      }
      @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.45; } }
      @keyframes g17-float-in {
        0%   { opacity: 0; transform: translateY(40px) scale(0.5); }
        60%  { opacity: 1; transform: translateY(-6px) scale(1.06); }
        100% { opacity: 1; transform: translateY(0) scale(1); }
      }
      .g17-float-timer { animation: g17-float-in 0.55s cubic-bezier(0.2, 0.9, 0.3, 1.2) both; }
      @media (prefers-reduced-motion: reduce) { .g17-float-timer { animation: none; } }
      @keyframes heartbeat {
        0%, 100% { transform: scale(1); }
        14%  { transform: scale(1.3); }
        28%  { transform: scale(1); }
        42%  { transform: scale(1.18); }
        56%  { transform: scale(1); }
      }
      @keyframes scanLine {
        0%   { transform: translateY(-100%); opacity: 0; }
        8%   { opacity: 0.6; }
        92%  { opacity: 0.6; }
        100% { transform: translateY(2000%); opacity: 0; }
      }
      @keyframes orb-drift-1 {
        0%,100% { transform: translate(0,0) scale(1); }
        33%     { transform: translate(60px,-40px) scale(1.1); }
        66%     { transform: translate(-30px,25px) scale(0.93); }
      }
      @keyframes orb-drift-2 {
        0%,100% { transform: translate(0,0) scale(1); }
        40%     { transform: translate(-70px,35px) scale(1.07); }
        70%     { transform: translate(40px,-20px) scale(0.96); }
      }
      @keyframes orb-drift-3 {
        0%,100% { transform: translate(0,0) scale(1); }
        50%     { transform: translate(25px,50px) scale(1.12); }
      }

      /* Nav pill slide */
      @keyframes nav-pill-in {
        from { opacity: 0; transform: scaleY(0.5); }
        to   { opacity: 1; transform: scaleY(1); }
      }
      @keyframes nav-ripple {
        0%   { transform: scale(0); opacity: 0.5; }
        100% { transform: scale(3); opacity: 0; }
      }
      @keyframes icon-pop {
        0%   { transform: scale(1); }
        40%  { transform: scale(1.35) rotate(-8deg); }
        70%  { transform: scale(0.92) rotate(4deg); }
        100% { transform: scale(1) rotate(0); }
      }
      @keyframes tab-in {
        from { opacity: 0; transform: translateX(-8px) scale(0.97); }
        to   { opacity: 1; transform: translateX(0) scale(1); }
      }

      /* Glow pulse on active nav */
      @keyframes glow-pulse {
        0%,100% { box-shadow: 0 0 0 0 rgba(${r},${g},${b},0); }
        50%     { box-shadow: 0 0 20px 4px rgba(${r},${g},${b},0.22); }
      }

      /* Number counter roll */
      @keyframes num-roll {
        from { transform: translateY(-100%); opacity: 0; }
        to   { transform: translateY(0); opacity: 1; }
      }

      /* Gradient border animation */
      @keyframes border-spin {
        from { --angle: 0deg; }
        to   { --angle: 360deg; }
      }

      /* ── PAGE & COMPONENT ANIMATIONS ── */
      .g17-page {
        animation: fadeUp 0.32s cubic-bezier(0.16, 1, 0.3, 1) both;
      }
      .g17-card {
        animation: scaleIn 0.26s cubic-bezier(0.16, 1, 0.3, 1) both;
      }
      .g17-modal {
        animation: scaleIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both;
      }
      .g17-slide-left  { animation: slideInLeft  0.26s cubic-bezier(0.16,1,0.3,1) both; }
      .g17-slide-right { animation: slideInRight 0.26s cubic-bezier(0.16,1,0.3,1) both; }
      .g17-bounce      { animation: bounceIn 0.42s cubic-bezier(0.16,1,0.3,1) both; }

      /* Staggered children */
      .g17-stagger > *:nth-child(1) { animation-delay: 0ms; }
      .g17-stagger > *:nth-child(2) { animation-delay: 40ms; }
      .g17-stagger > *:nth-child(3) { animation-delay: 80ms; }
      .g17-stagger > *:nth-child(4) { animation-delay: 120ms; }
      .g17-stagger > *:nth-child(5) { animation-delay: 160ms; }
      .g17-stagger > *:nth-child(6) { animation-delay: 200ms; }

      /* ── HOVER LIFT (cards) ── */
      .g17-hover-lift {
        transition: transform 0.28s cubic-bezier(0.16,1,0.3,1),
                    box-shadow 0.28s cubic-bezier(0.16,1,0.3,1),
                    border-color 0.28s ease;
        will-change: transform;
      }
      .g17-hover-lift:hover {
        transform: translateY(-4px) scale(1.005);
        box-shadow: 0 20px 48px rgba(${r},${g},${b},0.16), 0 4px 12px rgba(0,0,0,0.35);
        border-color: rgba(${r},${g},${b},0.4) !important;
      }

      /* ── BUTTONS ── */
      .g17-btn {
        transition: transform 0.12s cubic-bezier(0.16,1,0.3,1),
                    box-shadow 0.12s ease,
                    opacity 0.12s ease;
        position: relative; overflow: hidden;
      }
      .g17-btn::after {
        content: '';
        position: absolute; inset: 0;
        background: radial-gradient(circle at center, rgba(255,255,255,0.15) 0%, transparent 70%);
        opacity: 0; transition: opacity 0.2s;
        pointer-events: none;
      }
      .g17-btn:hover::after { opacity: 1; }
      .g17-btn:active { transform: scale(0.95); opacity: 0.88; }

      /* ── NAV ITEMS ── */
      .g17-nav-item {
        position: relative;
        transition: all 0.2s ease;
        font-family: 'Outfit', sans-serif;
        font-weight: 500; letter-spacing: 0.01em;
      }
      .g17-nav-item:hover {
        transform: translateY(-1px);
        opacity: 0.9;
      }
      /* Ripple on click */
      .g17-nav-item .nav-ripple {
        position: absolute; border-radius: 50%;
        background: rgba(${r},${g},${b},0.25);
        width: 10px; height: 10px;
        transform: scale(0); opacity: 0.5;
        pointer-events: none;
      }
      .g17-nav-item .nav-ripple.active {
        animation: nav-ripple 0.55s cubic-bezier(0.16,1,0.3,1) forwards;
      }
      /* Active indicator pill */
      .g17-nav-item.active {
        animation: glow-pulse 3s ease-in-out infinite;
      }

      /* ── SIDEBAR GLOW ── */
      .g17-sidebar {
        transition: box-shadow 0.4s ease;
      }

      /* ── PROFILE AVATAR RING ── */
      .g17-avatar-ring {
        transition: box-shadow 0.3s ease, border-color 0.3s ease, transform 0.3s ease;
      }
      .g17-avatar-ring:hover {
        transform: scale(1.06);
        box-shadow: 0 0 0 3px rgba(${r},${g},${b},0.5), 0 0 24px rgba(${r},${g},${b},0.3);
      }

      /* ── TOOLTIPS ── */
      a:hover .social-tooltip { opacity: 1 !important; transform: translateX(-50%) translateY(-3px) !important; }
      .social-tooltip { transition: opacity 0.2s ease, transform 0.2s ease !important; transform: translateX(-50%) translateY(0) !important; }

      /* ── SCROLLBAR ── */
      ::-webkit-scrollbar { width: 3px; height: 3px; }
      ::-webkit-scrollbar-track { background: transparent; }
      ::-webkit-scrollbar-thumb { background: rgba(${r},${g},${b},0.2); border-radius: 99px; }
      ::-webkit-scrollbar-thumb:hover { background: rgba(${r},${g},${b},0.5); }

      /* ── INPUTS ── */
      input, select, textarea {
        font-family: 'Outfit', sans-serif;
        transition: box-shadow 0.2s ease, border-color 0.2s ease;
      }
      input:focus, select:focus, textarea:focus {
        outline: none;
        /* Anel de foco tipo "alvo travado" */
        box-shadow: 0 0 0 1px rgba(${r},${g},${b},0.9), 0 0 0 4px rgba(${r},${g},${b},0.16), 0 4px 20px rgba(${r},${g},${b},0.1);
        border-color: rgba(${r},${g},${b},0.6) !important;
      }

      /* ── SELECTION ── */
      ::selection { background: rgba(${r},${g},${b},0.35); color: #fff; }

      /* ── MISC ── */
      .g17-num { transition: color 0.35s ease; }
      .g17-mono { font-family: var(--g17-mono); }

      /* Notification badge pulse */
      @keyframes notif-ping {
        0%   { transform: scale(1); opacity: 1; }
        75%  { transform: scale(2.2); opacity: 0; }
        100% { transform: scale(2.2); opacity: 0; }
      }
      .g17-notif-ping { animation: notif-ping 1.5s cubic-bezier(0,0,0.2,1) infinite; }

      /* Logo shine */
      @keyframes logo-shine {
        0%   { background-position: -200% center; }
        100% { background-position: 200% center; }
      }
      .g17-logo-text {
        background: linear-gradient(90deg, ${ac} 0%, ${logoShine} 40%, ${ac} 60%, ${logoShine} 100%);
        background-size: 200% auto;
        -webkit-background-clip: text; background-clip: text;
        -webkit-text-fill-color: transparent;
        animation: logo-shine 4s linear infinite;
      }

      /* Section divider shimmer */
      .g17-divider {
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(${r},${g},${b},0.25), transparent);
        margin: 0.5rem 0;
      }

      /* Tag chips */
      .g17-chip {
        display: inline-flex; align-items: center;
        padding: 0.18rem 0.6rem; border-radius: 99px;
        font-size: 0.7rem; font-weight: 700;
        transition: transform 0.15s ease, box-shadow 0.15s ease;
      }
      .g17-chip:hover { transform: scale(1.06); }

      /* Floating action button */
      .g17-fab {
        transition: transform 0.22s cubic-bezier(0.16,1,0.3,1), box-shadow 0.22s ease;
        box-shadow: 0 8px 24px rgba(${r},${g},${b},0.35);
      }
      .g17-fab:hover {
        transform: translateY(-3px) scale(1.05);
        box-shadow: 0 16px 40px rgba(${r},${g},${b},0.45);
      }
      .g17-fab:active { transform: scale(0.95); }

      /* ── TACTICAL SYSTEM (identidade visual G17) ── */
      .tac-num { font-family: var(--g17-mono); font-variant-numeric: tabular-nums; }

      /* "Recuo" (recoil) sutil de feedback ao concluir uma ação — ex.: bloco de estudo marcado como feito. */
      @keyframes tacRecoil {
        0%   { transform: translateX(0) scale(1); }
        22%  { transform: translateX(-5px) scale(0.985); }
        55%  { transform: translateX(2px) scale(1.006); }
        100% { transform: translateX(0) scale(1); }
      }
      .tac-recoil { animation: tacRecoil 0.4s cubic-bezier(0.16,1,0.3,1) both; }

      /* ── ESTILOS VISUAIS (escolhidos no Perfil) ── */
      .g17-shell { height: 100vh; height: 100dvh; }
      .g17-shell button, .g17-shell input, .g17-shell select, .g17-shell textarea { font-family: inherit; }
      .g17-style-tatico .g17-page h1, .g17-style-tatico .g17-page h2 {
        font-family: var(--g17-display); font-weight: 700 !important; letter-spacing: 0.01em !important;
      }
      .g17-style-institucional .g17-page h1, .g17-style-institucional .g17-page h2 {
        font-family: var(--g17-display); font-weight: 700 !important; letter-spacing: 0.03em !important; text-transform: uppercase;
      }
      .g17-style-foco .g17-page h1, .g17-style-foco .g17-page h2 { font-weight: 600 !important; }
      /* Estilos novos: sem brilho pulsante no item ativo do menu e cartões sem "pulo" exagerado */
      .g17-style-tatico .g17-nav-item.active, .g17-style-foco .g17-nav-item.active, .g17-style-institucional .g17-nav-item.active { animation: none; }
      .g17-style-foco .g17-hover-lift:hover, .g17-style-institucional .g17-hover-lift:hover { transform: none; }

      /* ── CELULAR ── */
      .g17-tabbar { display: none; }
      @media (max-width: 820px) {
        .g17-tabbar { display: grid; }
        /* Grades de 2 a 4 colunas viram 1 coluna (indicadores ficam 2x2). */
        .g17-page [style*="grid-template-columns: 1fr 1fr"],
        .g17-page [style*="grid-template-columns: 1.5fr 1fr"], .g17-page [style*="grid-template-columns: 1fr 1.2fr"],
        .g17-page [style*="grid-template-columns: 1fr 1.6fr"], .g17-page [style*="grid-template-columns: 1.4fr 1fr"],
        .g17-page [style*="grid-template-columns: repeat(2, 1fr)"],
        .g17-page [style*="grid-template-columns: 340px 1fr"], .g17-page [style*="grid-template-columns: 300px 1fr"],
        .g17-page [style*="grid-template-columns: 260px 1fr"], .g17-page [style*="grid-template-columns: 7rem 1fr"],
        .g17-page [style*="grid-template-columns: repeat(3, 1fr)"] {
          grid-template-columns: minmax(0, 1fr) !important;
        }
        .g17-page [style*="grid-template-columns: repeat(4, 1fr)"] { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }
        .g17-page .g17-grid-1 { grid-template-columns: minmax(0, 1fr) !important; }
        .g17-page .g17-grid-2 { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }
        /* Tabelas largas rolam de lado em vez de estourar a tela */
        .g17-page table { max-width: none; }
        /* Janelas (modais) nunca maiores que a tela */
        [style*="position: fixed"] > .g17-modal, [style*="position: fixed"] > div[style*="max-width"] { max-width: calc(100vw - 24px) !important; }
        .g17-page img { max-width: 100%; }
      }
    `}</style>
  );
}
